<script>
  export default {
    name: 'ReCaptcha',

    data: () => ({
      sitekey: process.env.VUE_APP_GOOGLE_RECAPTCHA_SITE_KEY,
      captchaId: 0,
    }),

    async created() {
      const scriptData = await this.$store.dispatch('getGoogleRecaptchaParam');
      const scriptElement = document.createElement('script');
      scriptElement.src = scriptData.script;
      scriptElement.onload = () => this.render();

      document.head.appendChild(scriptElement);
    },

    methods: {
      // Method is called outside via $refs
      execute() {
        if (window.grecaptcha) {
          window.grecaptcha.execute(this.captchaId);
        }
      },

      reset() {
        if (window.grecaptcha) {
          window.grecaptcha.reset(this.captchaId);
        }
      },

      async render() {
        await this.$nextTick();

        if (window.grecaptcha) {
          window.grecaptcha.ready(() => {
            this.captchaId = window.grecaptcha.render('g-recaptcha', {
              sitekey: this.sitekey,
              size: 'invisible',
              callback: (response) => {
                this.$emit('verify', response);
                this.reset();
              },
            });
          });
        } else {
          console.warn('window.grecaptcha is not ready');
        }
      },
    },
  };
</script>

<template>
  <div id="g-recaptcha" :data-sitekey="sitekey" />
</template>
